export default {
    ENABLED: 16,
    DISABLED: 0,
};
